import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import PromptConfirmation from './PromptConfirmation';


export default () => {
	const [shouldShow, setShouldShow] = useState(false);
	const [modalShow, setModalShow] = useState(true);
    const [modalStep, setModalStep] = useState(1);

 const imageMap = {
        1: "../images/Raya Travel Insurance Campaign.png",
        2: "../images/Premium Lounge Access- Image.png"
    };

const handleModalClose = () => {
  if (modalStep === 1) {
    setModalShow(false); // Close first modal

    // Add a delay before showing the second modal
    setTimeout(() => {
      setModalStep(2);
     setModalShow(true);
    }, 500); // Delay in milliseconds (500ms = 0.5 seconds)
  } else {
    setModalShow(false); // Close second modal
  }
};


	return (
		<>
			<section id="header" className="d-flex align-items-sm-center">
			</section>
			<section id="body">
            <PromptConfirmation
                show={modalShow}
                onHide={handleModalClose}
                imageSrc={imageMap[modalStep]}
            />

				<div className="container">
					<div className="row">
						<div className="col-12">
							<div className="row shadow title mt-n5 position-relative justify-content-center">
								<div className="col-12 align-self-center text-center">
									<h1 className="my-5 mr-sm-5 text-white">Welcome to <span className='font-weight-bold'>COSWAY Members</span> Insurance Hub
									</h1>
								</div>
							</div>
							<div className="row content">
								<div className="col-1"></div>
								<div className="col-10 shadow bg-white rounded">
									<div className="row text-primary mt-4 px-sm-5 py-sm-3">
										<div className="col-12 mt-1 px-5 mobile-padding">
											<h5>
												Explore the following offerings tailored just for you :
											</h5>
											<h5>
												<ol>
													<li><b>Motor Insurance</b><br />Instant comparison with key insurance companies and takaful operators in Malaysia.</li>
													<li><b>Travel Insurance</b><br />Ensure you are safeguarded and prepared for unforeseen circumstances.</li>
												</ol>
											</h5>
										</div>
										<div className="col-12 mt-1 px-5 mobile-padding">
											<h3 className="font-weight-bold mt-5 mb-5 text-center">
												COMPARE & CUSTOMIZE WITH JUST A FEW CLICKS
											</h3>
											<div className="row">
												<div className="col-lg-6 text-center">
													<a href="https://instapol.my/motor?r=COSWAY">
														<img src="../images/motor-button.png" id="instapol-logo" alt="Instapol" className="mobile-image" loading="lazy" />
													</a>
												</div>
												<div className="col-lg-6 text-center">
													<a href="https://howden-travelplus.instapol.my/landing?r=COSWAY">
														<img src="../images/travel-button.png" id="instapol-logo" alt="Instapol" className="mobile-image" loading="lazy" />
													</a>
												</div>
											</div>
										</div>
									</div>
									<div className="row d-none d-sm-flex mb-4">
										<div className="col-12 pr-5 text-right">
											<small>* Terms and conditions apply.</small>
										</div>
									</div>
								</div>
								<div className="col-1"></div>
							</div>
						</div>
					</div>
					<div className="row ml-1 justify-content-center mt-5 mb-5 px-3 mobile-content">
						<div className="col-lg-12 text-center">
							<h2 className="text-primary font-weight-bold">HOW</h2>
						</div>
						<div className="col-lg-12 text-center">
							<img src="../images/new-logo-02.png" id="instapol-logo" alt="Instapol" className="mobile-logo" loading="lazy" />
						</div>
						<div className="col-lg-12 text-center mb-3">
							<h2 className="text-primary font-weight-bold">MAKES INSURANCE AND TAKAFUL EASY</h2>
						</div>
						<div className="col-lg-4 mx-2">
							<div className="row">
								<div className="num d-flex justify-content-center align-items-center rounded-circle text-white bg-primary">1</div>
								<h4 className="col-9 text-primary font-weight-bold">Compare</h4>
							</div>
							<p className="mobile-padding-1">instaPol shows you how policies and takaful certificates match up, at a glance.</p>
						</div>
						<div className="col-lg-4 mx-2">
							<div className="row">
								<div className="num d-flex justify-content-center align-items-center rounded-circle text-white bg-primary">2</div>
								<h4 className="col-9 text-primary font-weight-bold">Customize</h4>
							</div>
							<p className="mobile-padding-1">Choose which features of the cover you want to pay for.</p>
						</div>
						<div className="col-lg-4 mx-2">
							<div className="row">
								<div className="num d-flex justify-content-center align-items-center rounded-circle text-white bg-primary">3</div>
								<h4 className="col-9 text-primary font-weight-bold">Buy Online</h4>
							</div>
							<p className="mobile-padding-1">Pay with credit or debit card and start the cover whenever it suits you.</p>
						</div>
						<div className="col-lg-4 mx-2">
							<div className="row">
								<div className="num d-flex justify-content-center align-items-center rounded-circle text-white bg-primary">4</div>
								<h4 className="col-9 text-primary font-weight-bold">Enjoy Aftercare Support</h4>
							</div>
							<p className="mobile-padding-1">Claims can be stressful. Let us take the strain.</p>
						</div>
					</div>
				</div>
				<section id="info" style={{backgroundColor: '#082461'}}>
					<div className="body-container p-5">
						<div className="row justify-content-center text-white">
							<div className="col-12 col-lg-5 text-center text-lg-end aos-init">
								<img src="../images/info_1.png"/>
							</div>
							<div className="col-12 col-lg-7 text-lg-start align-self-center">
								<h3 className="font-weight-bold text-uppercase">Know What You're Buying And Why</h3>
								<p className="description">instaPol makes comparing fast and easy. The simple comparison table reveals why some policies/takaful products cost more than others, so you can make an informed choice.</p>
							</div>
						</div>
						<div className="row justify-content-center text-white">
							<div className="col-12 col-lg-5 text-center text-lg-end">
								<img src="../images/info_2.png"/>
							</div>
							<div className="col-12 col-lg-7 text-lg-start align-self-center">
								<h3 className="font-weight-bold text-uppercase">Making Your Purchase Simple And Convenient For All</h3>
								<p className="description">We offer instaPol as an exclusive benefit to the employees of Howden clients and members of affinity partners. We also welcome all who visit us. It is our commitment to serve you better.</p>
							</div>
						</div>
						<div className="row justify-content-center text-white">
							<div className="col-12 col-lg-5 text-center text-lg-end">
								<img src="../images/info_3.png"/>
							</div>
							<div className="col-12 col-lg-7  text-lg-start align-self-center">
								<h3 className="font-weight-bold text-uppercase">On Your Side When You Make A Claim</h3>
								<p className="description">As your broker, we represent the interests of our customers, not the insurer, which means we are 100% on your side when you make a claim.</p>
							</div>
						</div>
					</div>
				</section>
				<div className="row pds text-white">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12 text-center">
                                <h5 className="my-4 font-weight-bold">Howden is an approved Insurance and Takaful Broker Under the Financial Services Act 2013 & Islamic Financial Services Act 2013 and Regulated by Bank Negara Malaysia</h5>
                            </div>
                        </div>
						<div className='row'>
							<div className="col-12">
								<div className="row align-items-center  rounded-pill p-3  mb-4 bg-white">
									<div className="col-4 col-sm-2">
										<img src="../images/am.png" className="img-fluid"/>
									</div>
									<div className="col-4 col-sm-2">
										<img src="../images/zurich-takaful.png" className="img-fluid"/>
									</div>
									<div className="col-4 col-sm-2">
										<img src="../images/zurich.png" className="img-fluid"/>
									</div>
									<div className="col-4 col-sm-2">
										<img src="../images/allianz.png" className="img-fluid"/>
									</div>
									<div className="col-4 col-sm-2">
										<img src="../images/liberty.png" className="img-fluid"/>
									</div>
									<div className="col-4 col-sm-2">
										<img src="../images/sompo.png" className="img-fluid"/>
									</div>
									<div className="col-4 col-sm-2">
										<img src="../images/lonpac.png" className="img-fluid"/>
									</div>
									<div className="col-4 col-sm-2">
										<img src="../images/tuneprotect.png" className="img-fluid"/>
									</div>
									<div className="col-4 col-sm-2">
										<img src="../images/aig.png" className="img-fluid"/>
									</div>
									<div className="col-4 col-sm-2">
										<img src="../images/chubb.png" className="img-fluid"/>
									</div>
								</div>
							</div>
						</div>
						<div className="row">
                            <div className="col-12 text-center">
                                <h5 className="my-4 font-weight-bold">All insurers on our platform are licensed under the Financial Services Act 2013 & Islamic Financial Services Act 2013 and regulated by Bank Negara Malaysia</h5>
                            </div>
							<div className="col-12 text-center">
                                <h5 className="my-4 font-weight-bold">All insurers on our platform are members of PIDM.  The benefit(s) payable under eligible policy is protected by PIDM up to limits.  Please refer to <a href="https://www.pidm.gov.my/pidm2022/files/92/92bdfcde-3534-4a29-9031-5186387623ee.pdf" target="_blank" class="text-white">PIDM's TIPS BROCHURE</a> or contact your insurer or <a href="https://pidm.gov.my/en" target="_blank" className="text-white">PIDM</a></h5>
                            </div>
                        </div>
                    </div>
                </div>
			</section>
			<Modal show={shouldShow} onHide={() => setShouldShow(false)}>
				<Modal.Header closeButton>
					<Modal.Title>Reminder</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="row">
						<div className="col-12 text-center">
							<img src='../images/minimum-amount.png' className="img-fluid" width={330} />
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" size="sm" onClick={() => setShouldShow(false)}>OK</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
}
